import { Settings as LayoutSettings, PageLoading, BasicLayoutProps } from "@ant-design/pro-layout";
import { history } from "umi";
import React from "react";
import defaultSettings from '../config/defaultSettings';
import RightContent from "@/components/RightContent";
import Footer from "@/components/Footer";
import { getUser } from "./services/user";
import clientSocket from '@/services/clientSocket';
import { userInfoManager } from '@/utils/userInfo';

const loginPath = '/welcome';

/** 获取用户信息比较慢的时候会展示一个 loading */
export const initialStateConfig = {
  loading: PageLoading,
};

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        history.replace(loginPath);
        return undefined;
      }
      const { resp } = await getUser();
      if (resp.code === 0) {
        const data = resp.data;
        return {
          name: data.name,
          avatar: data.avatar,
          userid: data.userid,
          permission: data?.permission,
          role: data?.role,
          org: data?.org,
        }
      } else {
        history.replace(loginPath);
      }
      return undefined;
    } catch (error) {
      history.replace(loginPath);
    }
  };
  // 如果不是是登录页面，执行
  if (history.location.pathname !== loginPath) {
    const currentUser = await fetchUserInfo();
    // 设置全局用户信息
    if (currentUser) {
      userInfoManager.setCurrentUser(currentUser);
    }
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings,
    };
  }
  return {
    fetchUserInfo,
    settings: {},
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout = ({ initialState }: { initialState: { settings?: LayoutSettings; currentUser?: API.CurrentUser }; }): BasicLayoutProps => {
  // 设置全局用户信息
  if (initialState?.currentUser) {
    userInfoManager.setCurrentUser(initialState.currentUser);
  }

  clientSocket.setUser(initialState.currentUser?.userid!);
  return {
    title: 'BB8',
    logo: require('@/assets/logo.svg'),
    rightContentRender: RightContent,
    disableContentMargin: true,
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    menuFooterRender: () => React.createElement(Footer),
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    ...initialState?.settings,
  };
};
